import { z } from 'zod';

export const createCurrencySchema = z.object({
  code: z.string()
    .min(1, 'Code is required')
    .max(10, 'Code must be 10 characters or less')
    .regex(/^[A-Za-z]+$/, 'Code must contain only letters'),
  name: z.string().min(1, 'Name is required'),
  symbol: z.string().max(10).optional(),
  type: z.enum(['fiat', 'crypto']),
  decimals: z.coerce.number().min(0).max(18),
});

export const editCurrencySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  symbol: z.string().max(10).optional(),
  type: z.enum(['fiat', 'crypto']),
  decimals: z.coerce.number().min(0).max(18),
  isActive: z.boolean(),
});

export type CreateCurrencyFormData = z.infer<typeof createCurrencySchema>;
export type EditCurrencyFormData = z.infer<typeof editCurrencySchema>;
